import { Box, List } from '@mui/material'

import { type SurveyDefinitionByUserResponse } from '~/api'

import type { SurveyDynamicModel } from '../types/survey-dynamic-model.type'
import { DynamicLinksSurveyItem } from './DynamicLinksSurveyItem'

interface DynamicLinksSurveyGroupProps {
  title: string
  surveys: SurveyDynamicModel[]
  surveyDefinitionsByUser: SurveyDefinitionByUserResponse[]
}

export function DynamicLinksSurveyGroup({
  title,
  surveys,
  surveyDefinitionsByUser,
}: DynamicLinksSurveyGroupProps) {
  function getSurveyDefinitionTitle(
    surveyDefinitionId: number,
  ): string | undefined {
    const surveyDefinition = surveyDefinitionsByUser.find(
      def => def.id === surveyDefinitionId,
    )
    return surveyDefinition ? surveyDefinition.title : undefined
  }

  return (
    <Box sx={{ mt: 3 }}>
      {/* Title is not needed since the surveys are already grouped by survey definition and the survey definition title is displayed in each survey item */}
      <Box
        sx={{
          backgroundColor: theme => theme.palette.background.paper,
          borderRadius: 1,
        }}
      >
        <List sx={{ p: 0 }}>
          {surveys.map((survey, index) => (
            <DynamicLinksSurveyItem
              key={survey.id}
              data={survey}
              isLast={index === surveys.length - 1}
              surveyDefinitionTitle={getSurveyDefinitionTitle(
                survey.surveyDefinition,
              )}
            />
          ))}
        </List>
      </Box>
    </Box>
  )
}
